import { all, fork } from "redux-saga/effects";
import { watchDashboardSaga } from "./dashboardSaga";
import { watchDijikolaySaga } from "./dijikolaySaga";
import { watchClientsSaga } from "./clientsSaga";


export default function* rootSaga() {
    yield all([
        fork(watchDashboardSaga),
        fork(watchDijikolaySaga),
        fork(watchClientsSaga),
    ]);
}